import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';
import { useDebt } from '../../context';
import { OrderKind } from 'consts/enums/order';
import AnimatedToggle from 'components/generics/toggles/AnimatedToggle';
import classes from './index.module.scss';

const TOGGLE_TYPES_TO_PROPS = {
  [OrderKind.BUY]: {
    label: 'Buy',
  },
  [OrderKind.SELL]: {
    label: 'Redeem',
  },
};

const TradeFormToggle = ({ className }: HTMLAttributes<HTMLDivElement>) => {
  const { setOrderKind } = useDebt();

  const isAllowToRedeem = true;
  if (!isAllowToRedeem) return <div />;

  const toggleItems = Object.entries(TOGGLE_TYPES_TO_PROPS).map(
    ([key, value]) => ({
      value: key,
      label: value.label,
    })
  );

  return (
    <AnimatedToggle
      disabled={!isAllowToRedeem}
      className={classNames(classes.container, className)}
      switcherClassName={classes.switcher}
      itemClassName={classes.item}
      activeItemClassName={classes.activeItem}
      onChangeValue={(value: string) => setOrderKind(value as OrderKind)}
      items={toggleItems}
    />
  );
};

export default TradeFormToggle;
